<template>
	<div class="tab-pane fade" id="tab-workplacesublocal" role="tabpanel" aria-labelledby="workplacesublocal-tab">

		<div class="row section-top">
			<div class="col-md-12 pad0">
				<p class="section-lead">Lista de todos Sublocais vinculados</p>
				<a href="#" @click="resetForm()" class="btn btn-outline-success float-right" data-toggle="modal" data-target="#modalSublocal"><i class="fas fa-plus"></i>&nbsp;Novo</a>
			</div>
		</div>

		<div class="row">
			<div class="col">

				<!-- table -->
				<div class="card p-4">
					<vue-good-table v-if="sublocalItems.length"
						:columns="tableColumns"
						:rows="sublocalItems"
						:pagination-options="tablePagination"
						:search-options="{
							enabled: true,
							placeholder: 'Buscar..',
						}"
						styleClass="vgt-table"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<div>
									<button class="btn btn-sm btn-outline-secondary" @click="editData(props.row)" title="Editar"><i class="far fa-edit"></i></button>
									<button class="btn btn-sm btn-outline-danger" @click="deleteData(props.row.id, props.row.originalIndex)" title="Deletar"><i class="far fa-trash-alt"></i></button>
								</div>
							</span>
							<span v-else>
								{{ props.formattedRow[props.column.field] }}
							</span>
						</template>
					</vue-good-table>
					<div v-else class="text-center p-3 text-muted">
						<h5>Nenhum Sublocal vinculado!</h5>
					</div>
				</div>

				<div class="text-center p-4 text-muted" v-if="loading">
					<h5>Carregando...</h5>
					<p>Aguarde até que os dados sejam carregados...</p>
				</div>

			</div>

			<!-- modal -->
			<div class="modal fade" id="modalSublocal" tabindex="-1" aria-labelledby="modalSublocalLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="modalSublocalLabel">{{modalSublocalTitle}}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<form v-on:submit.prevent="saveData">

								<div class="row">

                  <!-- sublocal -->
                  <div class="col-md-12">
										<div class="form-group">
											<label class="form-control-label" for="input-sublocal_id">Selecione o Sublocal</label>
											<v-select :options="sublocal" label="corporate_name" v-bind:class="{'is-invalid': errors.workplace}" v-model="sublocal_id" :reduce="corporate_name => corporate_name.id"></v-select>
											<div class="invalid-feedback d-block" v-if="errors.sublocal_id">
												<p>{{ errors.sublocal_id[0] }}</p>
											</div>
										</div>
									</div>
							
								</div>

								<div class="text-right">
									<button type="submit" class="btn btn-success">SALVAR</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<!-- end modal -->

		<vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
		</div>
	</div>
</template>

<script>
	import ApiService from '../../../apiservice.js';
	export default {
		mixins: [ApiService],
		props: ['workplaces'],
		data() {
			return {
				modalSublocalTitle: "Vincular Sublocal",
				sublocalID: '',
        workplaceID: '',
				isEditSublocal: false,
				companyWorkPlaceID: "",
        sublocal: [],
				sublocalItems: [],
				fullPage: true,
				errors: [],
				loading: false,
        sublocal_id: '',
				tablePagination: {
					enabled: true,
					nextLabel: "próxima",
					prevLabel: "anterior",
					rowsPerPageLabel: "Registros por página",
					tofLabel: "de",
					pageLabel: "página",
					allLabel: "Todos",
				},
				tableColumns: [
					{
						label: 'Sublocal',
						field: 'sublocal.corporate_name',
					},{
						label: 'Data e Hora',
						field: 'created_at',
						type: 'date',
						dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
						dateOutputFormat: 'dd/MM/yyyy HH:mm:ss'
					},
					{
						label: 'Ações',
						field: 'actions',
						sortable: false,
						width: '100px'
					}
				]
			}
		},
		mounted() {
			this.workplaceID = (JSON.parse(this.workplaces)).id;
      this.loadSublocal();
      this.loadItems();
		},
		methods: {
      loadSublocal() {
				let _this = this;
				_this.loading = true;
				_this.sublocal = [];
				axios.get("/admin/sublocal").then((res) => {
          _this.sublocal = _this.sublocal.concat(res.data);
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
			loadItems() {
				let _this = this;
				_this.loading = true;
				_this.sublocalItems = [];
				axios.get("/admin/workplacesublocal/"+this.workplaceID+"/search").then((res) => {
					_this.sublocalItems = _this.sublocalItems.concat(res.data);
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
			saveData() {
				let _this = this;
				_this.errors = [];
				_this.loading = true;
				
				if (_this.isEditSublocal == true){

					let dataInfo = {
						"workplace": _this.workplaceID,
            "sublocal": _this.sublocal_id,
						"_method": "PATCH"
					};

					axios.post("/admin/workplacesublocal/"+_this.workplaceID, dataInfo).then((res) => {

						_this.loading = false;
						_this.resetForm();

						$('#modalSublocal').modal('hide');

						//call function in ApiService to validate success
						_this._api_validateSuccess(res,false);

					}).catch((err) => {

						_this.loading = false;

						if (err.response.data.errors){
							//set errors
							_this.errors = err.response.data.errors;
						}
						//call function in ApiService to validate error
						_this._api_validateError(err);

					});

				} else {

					let dataInfo = {
						"workplace": _this.workplaceID,
            "sublocal": _this.sublocal_id,
						"last": ""
					};
					axios.post("/admin/workplacesublocal", dataInfo).then((res) => {

						_this.loading = false;
						_this.resetForm();

						_this.sublocalItems.push(res.data.data);
						$('#modalSublocal').modal('hide');

						//call function in ApiService to validate success
						_this._api_validateSuccess(res,false);

					}).catch((err) => {

						_this.loading = false;

						if (err.response.data.errors){
							//set errors
							_this.errors = err.response.data.errors;
						}

						//call function in ApiService to validate error
						_this._api_validateError(err);

					});
				}
			},
			deleteData(ID, index) {
				let _this = this;

				//show alert confirmation
				_this.$swal({
					title: "Excluir vínculo de Sublocal",
					text: "Tem certeza que deseja excluir esse vínculo?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonText: "Excluir",
					cancelButtonText: "Cancelar"
				}).then((alertConfirm) => {

					//validate isConfirmed
					if (alertConfirm.isConfirmed) {

						//remove
						axios.delete("/admin/workplacesublocal/"+ID).then((res) => {

							_this.sublocalItems.splice(index, 1);

							//call function in ApiService to validate success
							_this._api_validateSuccess(res,false);

						}).catch(err => {

							_this.loading = false;

							//call function in ApiService to validate error
							_this._api_validateError(err);

						});

					}//end validate isConfirmed

				});
				//end alert confirmation

			},
			editData(item){

        this.sublocal_id = item.sublocal_id;

				this.isEditSublocal = true;
				this.companyWorkPlaceID = item.id;
				this.modalSublocalTitle = "Editar vínculo de Sublocal";

				$("#modalSublocal").modal('show');

			},
			resetForm(){

        this.sublocal_id = "";

				this.loadSublocal();

			}
		}
	}
</script>
